import { render } from "./PlanCard.vue?vue&type=template&id=77cdef28&scoped=true"
import script from "./PlanCard.vue?vue&type=script&lang=js"
export * from "./PlanCard.vue?vue&type=script&lang=js"

import "./PlanCard.vue?vue&type=style&index=0&id=77cdef28&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-77cdef28"]])

export default __exports__